import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'src/app/store';
import {
  ObjectInfo,
  PAGE_LAYOUT_TYPE,
  selectIsMobileWeb,
  selectObjectInfo,
} from 'src/app/slice';
import didElementLoad from 'src/commons/utils/didElementLoad';
import { ConnectedObjectInfo } from './ObjectInfo';
import SectionNav, { SectionNavProps } from '../SectionNav/SectionNav';
import { ConnectedPageLevelBannersWithAces } from '../Banners/Common/BannerWithAces';
import { PageHeaderWrapper, RodeoContainer } from './styles';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';

interface PageHeaderProps {
  subsections?: SectionNavProps;
  objectInfo?: ObjectInfo;
  isMobileDevice: boolean;
}

export const PageHeader: React.VFC<PageHeaderProps> = ({
  objectInfo,
  isMobileDevice,
}) => {
  const chromeConfig = useChromeConfigContext();
  const isFocusLayout =
    chromeConfig.pageLayoutType === PAGE_LAYOUT_TYPE.FOCUS ||
    chromeConfig.pageLayoutType === PAGE_LAYOUT_TYPE.FOCUS_NO_HEADER;
  const breadcrumbs = chromeConfig.breadcrumbs || [];
  const subsections = chromeConfig.pageHeader?.subsections;

  const hasSubsections = subsections && subsections?.items?.length > 0;
  const hasPageTitle = breadcrumbs.length > 0;

  useEffect(() => {
    if (hasSubsections || objectInfo || hasPageTitle) {
      didElementLoad('pageHeader');
    }
  }, []);

  if (hasSubsections || hasPageTitle || objectInfo) {
    return (
      <PageHeaderWrapper
        id="pageHeader"
        data-ccx-e2e-id="aac-pageheader"
        isMobileDevice={isMobileDevice}
      >
        <ConnectedPageLevelBannersWithAces />
        {!isFocusLayout && (
          <>
            <ConnectedObjectInfo />
            {subsections && subsections?.items?.length > 0 && (
              <SectionNav
                selectedItemId={subsections.selectedItemId}
                items={subsections.items}
                isMobile={isMobileDevice}
              />
            )}
          </>
        )}
        {!!window.AACChromeUI && (
          <>
            <section
              id="page-header-section"
              className="page-header-section"
              {...getTaktAttributes('page-header', chromeComponents.HEADER)}
            />
            <RodeoContainer id="main-container" />
          </>
        )}
      </PageHeaderWrapper>
    );
  }

  return <ConnectedPageLevelBannersWithAces withPageHeaderWrapper={true} />;
};

const mapStateToProps = (state: RootState) => {
  return {
    objectInfo: selectObjectInfo(state),
    isMobileDevice: selectIsMobileWeb(state),
  };
};

export const ConnectedPageHeader = connect(mapStateToProps)(PageHeader);
